import { useState } from 'react';
import { API } from '../../../api/api';
import { URLS } from '../../../api/urls';
import { DeleteConfirmationModal } from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import { ALERT_TEXT } from '../../../constants/content';
import { useAlert } from '../../../context/Alert.context';

interface DeletePageModalProps {
  open: boolean;
  onClose: () => void;
  id: string;
  updateMailsAfterDelete: (mailId: string) => void;
}

export const DeleteBusinessRequestModal = ({
  open,
  onClose,
  id,
  updateMailsAfterDelete,
}: DeletePageModalProps) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const onDelete = () => {
    setLoading(true);
    API.delete(`${URLS.BUSINESS}/${id}`)
      .then(() => {
        updateMailsAfterDelete(id);
        onClose();
        showAlert({
          message: ALERT_TEXT.BUSINESS_REQUEST_SUCCESS,
          severity: 'success',
        });
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() => setLoading(false));
  };

  return (
    <DeleteConfirmationModal
      loading={loading}
      onClose={onClose}
      open={open}
      titleItem={'Business Request'}
      onDelete={onDelete}
    />
  );
};
